import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ImpersonationService } from "@/services/users/ImpersonationService";
import { UserService } from "@/services/users/UserService";
import type { InboxFilters } from "@/types/conversation/conversation";

const KEY = ["inbox-filters"];

/** The signed-in user's remembered Conversations inbox filters. */
export const useInboxFilters = () =>
  useQuery({
    queryKey: KEY,
    queryFn: () => UserService.getInboxFilters(),
    staleTime: Infinity,
  });

/** Remembers the filters. An admin looking through a customer's account never overwrites the customer's own choice. */
export const useSaveInboxFilters = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (filters: InboxFilters) =>
      ImpersonationService.isImpersonating() ? filters : UserService.saveInboxFilters(filters),
    onMutate: (filters) => queryClient.setQueryData(KEY, filters),
  });
};
